'use strict';

const h = require('phy');
const MSRPLabel = require('../../../../msrp/components/label');

module.exports = msrp => {
  return msrp &&
    msrp.optionsMsrpHash &&
    Object.keys(msrp.optionsMsrpHash).length
    ? h(MSRPLabel, msrp)
    : null;
};
